import { Stack, Tooltip } from '@mui/material';
import React from 'react'
import GlobalSearch from '../../components/Search';
import { useDispatch, useSelector } from 'react-redux';
import { setGridView } from '../../redux/SearchSlice';
import { localStorageInstance } from '../../utils/localStorage';
import gridActiveIcon from "../../styles/svg/grid-view-active.svg";
import gridInactiveIcon from "../../styles/svg/grid-view-inactive.svg";
import listActiveIcon from "../../styles/svg/list-view-active.svg";
import listInactiveIcon from "../../styles/svg/list-view-inactive.svg";

export const DeskTopHeader = ({handleChange, inputValue,TooltipName, }) => {
    const gridView = useSelector((state) => state.search.gridView);
    const dispatch = useDispatch();

    return (
        <Stack direction="row" justifyContent="space-between" mb={1}>
            <p className="board-heading-name">Watching Tasks</p>
            <Stack direction="row" alignItems={"center"}>
                <Stack className="grid-list-cont mr-2">
                    <Tooltip title={TooltipName.KANBAN_VIEW}>
                        <img
                            src={gridView ? gridActiveIcon : gridInactiveIcon}
                            alt="gridIcon"
                            onClick={
                                () => {
                                    if (gridView) {
                                    } else {
                                        dispatch(setGridView());
                                    }
                                    localStorageInstance.setItem({
                                        key: "showGridView",
                                        value: true,
                                    });
                                }
                                //  (gridView ? "" : dispatch(setGridView()))
                            }
                        />
                    </Tooltip>
                    <Tooltip title={TooltipName.LIST_VIEW}>
                        <img
                            src={gridView ? listInactiveIcon : listActiveIcon}
                            alt="listIcon"
                            onClick={
                                () => {
                                    if (gridView) {
                                        dispatch(setGridView());
                                    } else {
                                    }
                                    localStorageInstance.setItem({
                                        key: "showGridView",
                                        value: false,
                                    });
                                }
                            }
                        />
                    </Tooltip>
                </Stack>
                <GlobalSearch
                    placeholder={"Search.."}
                    searchText={inputValue}
                    handleChange={handleChange}
                />
            </Stack>
        </Stack>
    )
}


